import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const RegisterWithoutVerifications: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);
  const isAvailable = useIsFeatureAvailable('register_without_verification');

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.REGISTER_WITHOUT_VERIFICATION,
            value: value ? '1' : '0',
          })
        }
        emptyBg
        variant="secondary"
        description={t('settings.shell.authorization.description')}
        value={settings.registerWithoutVerification}
        label={t('settings.shell.authorization.title')}
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
        disabled={!isAvailable}
      />
    </>
  );
};
